import React from "react"
import { Dropdown, Avatar } from "antd"
import { useNavigate } from "react-router-dom"
import { UserOutlined, LoginOutlined } from "@ant-design/icons"
import apiClient from "../../../api/client/ApiClient"
import { useStore } from "../../ui"
import { DEFAULT_AVATAR_URL } from "../../../lib/defaultAvatar"

const Header = ({ user }) => {
  const { logOut } = useStore()
  const navigate = useNavigate()

  const doLogout = async () => {
    try {
      // Gọi logout API với credentials để gửi cookies
      await apiClient.post("auth/logout/", {}, { withCredentials: true })
    } catch (e) {
      console.log("Logout API error (có thể cookies đã hết hạn):", e)
    } finally {
      logOut()
      navigate("/login", { replace: true })
    }
  }

  const menuItems = [
    { key: "profile", icon: <UserOutlined />, label: "Tài khoản", onClick: () => navigate("/profile") },
    { key: "logout", icon: <LoginOutlined />, label: "Đăng xuất", onClick: doLogout }
  ]

  return (
    <div className="flex">
      <Dropdown menu={{ items: menuItems }} placement="bottomLeft">
        <div className="cursor-pointer flex justify-center items-center">
          <div className="flex items-center justify-center hover-sb mr-2">
            <Avatar
              size={30}
              src={user?.avatar || DEFAULT_AVATAR_URL}
            />
          </div>
          <span className="user-name text-white ml-2">{user?.full_name || user?.email || "User"}</span>
        </div>
      </Dropdown>
    </div>
  )
}

export default Header
